import { render, staticRenderFns } from "./UsuariosCadastroParceiro.vue?vue&type=template&id=30e7e014&"
import script from "./UsuariosCadastroParceiro.vue?vue&type=script&lang=ts&"
export * from "./UsuariosCadastroParceiro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports